import styles from '../styles/helppage.module.scss';
import BaseMenu from '@base/features/help/components/baseMenu';

export default function BaseHelpPage(props: { children: JSX.Element; routes: string[] }) {
  return (
    <div className={styles.helpPage}>
      <BaseMenu>{props.routes}</BaseMenu>
      {props.children}
    </div>
  );
}
